// extracted by mini-css-extract-plugin
module.exports = {"container":"RichText_container__m3sZB","center":"RichText_center__gZyZx"};